import axios, { CancelToken } from 'axios';
import { LocalStorageKeysEnum } from 'src/shared/enum';
import environment from '../environment/environment';
import * as models from '../models/index';
import { IUserAuthResponse } from '../models/index';
import { Constant, clientRoutes } from 'src/shared/constants';
import { SharedService } from './shared.service';
import cryptoJS from 'crypto-js';
const jwtCheckExpiration = require('jwt-check-expiration');
export class UserService {
	private userApiUrl = environment.apiGateway.apiUrl + 'User/';
	private authApiUrl = environment.authMS.apiBaseUrl + 'auth/';
	private authMSApiUrl = environment.authMS.apiBaseUrl;

	// /**
	//  *  Returns UserData from from sessionStorage or localStorage
	//  */
	// public static GetLocalUserData = (): IUserAuthResponse => {
	// 	let sessionAuthString = sessionStorage.getItem(LocalStorageKeysEnum.UserData);
	// 	let sessionAuthData;
	// 	if(sessionAuthString) {
	// 		sessionAuthData = JSON.parse(sessionAuthString);
	// 	}

	// 	let localAuthString = localStorage.getItem(LocalStorageKeysEnum.UserData);
	// 	let localAuthData;
	// 	if(localAuthString) {
	// 		localAuthData = JSON.parse(localAuthString);
	// 	}
		
	// 	return sessionAuthData || localAuthData || {};
	// };

	// /**
	//  * Sets UserData in localStorage or sessionStorage based on isStaySignedIn
	//  * @param data - UserData to save in sessionStorage or localStorage
	//  * @param isStaySignedIn - boolean 
	//  * 		- if true, UserData is saved in localStorage
	//  * 		- if false, UserData is saved in sessionStorage
	//  */
	// public static SetLocalUserData = (data: IUserAuthResponse, isStaySignedIn: boolean = false) => {
	// 	isStaySignedIn
	// 	? localStorage.setItem(LocalStorageKeysEnum.UserData, JSON.stringify(data))
	// 	: sessionStorage.setItem(LocalStorageKeysEnum.UserData, JSON.stringify(data))
	// };

	// /**
	//  *  Sign out user
	//  */
	//  public static ClearUserLocalData = () => {
	// 	localStorage.clear();
	// 	sessionStorage.clear();
	// }

	// public static GetAuthorizationToken = () : string | null => {
	// 	const userData = UserService.GetLocalUserData();
	// 	if (userData.token) {
	// 		return userData.token;
	// 	}

	// 	return null;
	// }
	
	// /**
	//  *  Sign in user
	//  */
	// public async SignIn(signInRequest: models.ISignInRequest, cancelToken?: CancelToken): Promise<IUserAuthResponse> {
	// 	try {
	// 		const res = await axios.post<IUserAuthResponse>(this.userApiUrl + 'SignIn', signInRequest, {
	// 			cancelToken,
	// 		});
	// 		return res.data;
	// 	} catch (error) {
	// 		throw error;
	// 	}
	// }

	// /**
	//  *  Sign up user
	//  */
	// public async SignUp(signUpRequest: models.ISignUpRequest, cancelToken?: CancelToken): Promise<IUserAuthResponse> {
	// 	try {
	// 		const res = await axios.post<IUserAuthResponse>(this.userApiUrl + 'SignUp', signUpRequest, {
	// 			cancelToken,
	// 		});
	// 		return res.data;
	// 	} catch (error) {
	// 		throw error;
	// 	}
	// }

	/**
	 *  Sign up user
	 */
	public async GetSSOURL(connection?: string, cancelToken?: CancelToken): Promise<string> {
		try {
			const res = await axios.get<string>(this.userApiUrl + 'SSO/URL', {
				params: {
					connection
				},
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Sign up user
	 */
	public async ResetPassword(email: string, cancelToken?: CancelToken): Promise<string> {
		try {
			const res = await axios.put<string>(this.userApiUrl + 'ResetPassword', null, {
				params: {
					email
				},				
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	//#region Auth MS region


	public async getAuthMSAccessToken(authCode:string, codeVerifier: string): Promise<models.AuthMSAuthDataVM> {
		try {
			const apiUrl = `${this.authApiUrl}authCode/token?code=${authCode}&codeVerifier=${codeVerifier}`;
			const res = await axios.get<models.AuthMSAuthDataVM>(apiUrl)
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * 
	 * @returns 
	 */
	public static isAuthMSAuthenticated(): boolean {
		const userData = UserService.GetAuthMsLocalUserData();
		return Boolean(userData?.accessToken || '') == true && !jwtCheckExpiration.isJwtExpired(userData?.accessToken);
	}

	/**
	 *  Returns UserData from from sessionStorage or localStorage
	 */
	public static GetAuthMsLocalUserData = (): models.AuthMSAuthDataVM => {
		let sessionAuthString = sessionStorage.getItem(LocalStorageKeysEnum.UserData);
		let sessionAuthData;
		if(sessionAuthString) {
			sessionAuthData = JSON.parse(sessionAuthString);
		}

		let localAuthString = localStorage.getItem(LocalStorageKeysEnum.UserData);
		let localAuthData;
		if(localAuthString) {
			localAuthData = JSON.parse(localAuthString);
		}
		
		return sessionAuthData || localAuthData || {};
	};
	
	/**
 	* Sets UserData in localStorage or sessionStorage based on isStaySignedIn
 	* @param data - UserData to save in sessionStorage or localStorage
 	* @param isStaySignedIn - boolean 
 	* 		- if true, UserData is saved in localStorage
 	* 		- if false, UserData is saved in sessionStorage
 	*/
	public static SetAuthMSLocalUserData = (data: models.AuthMSAuthDataVM, isStaySignedIn: boolean = false) => {
		isStaySignedIn
			? localStorage.setItem(LocalStorageKeysEnum.UserData, JSON.stringify(data))
			: sessionStorage.setItem(LocalStorageKeysEnum.UserData, JSON.stringify(data))
	};

	
	/**
	 *  Sign out user
	 */
	public static ClearAuthMSUserLocalData = () => {
		localStorage.clear();
		sessionStorage.clear();
	}

	public static GetAuthMSAuthorizationToken = (): string | null => {
		const userData = UserService.GetAuthMsLocalUserData();
		return userData?.accessToken || null;
	}

	/**
 	*  Sign out user
 	*/
	public static SignOut = () => {
		UserService.ClearAuthMSUserLocalData();
		window.location.href = environment.appSetting.baseUrl + clientRoutes.signIn;
	}

	public createCodeVerifier() {
		let verifier = SharedService.getGuid();
		UserService.setCodeVerifierInSession(verifier);
		return verifier;
	}

	public createCodeChallenge(verifier: string | null | undefined = '') {
		if (!verifier) {
			verifier = this.createCodeVerifier();
		}
		const hashed = cryptoJS.SHA256(verifier);
		let codeChallenge = hashed.toString();

		return codeChallenge;
	}

	public static setCodeVerifierInSession(codeVerifier: string) {
		sessionStorage.setItem(Constant.storageCodeVerifier, codeVerifier)
	}

	public static getCodeVerifierFromSession() {
		return sessionStorage.getItem(Constant.storageCodeVerifier)
	}

	public static removeCodeVerifierFromSession() {
		sessionStorage.removeItem(Constant.storageCodeVerifier)
	}

	//#endregion
}
